import OriginalReactCSSTransitionGroup from 'react-addons-css-transition-group'
import React from 'react'

// Overwrite the original ReactCSSTransitionGroup to automatically disable animation in tests.
//
const ReactCSSTransitionGroup = (props) => {
  if (window.testMode) {
    return (
      <OriginalReactCSSTransitionGroup
        {...props}
        transitionEnterTimeout={1}
        transitionAppearTimeout={1}
        transitionLeaveTimeout={1}
      />
    )
  } else {
    return <OriginalReactCSSTransitionGroup {...props} />
  }
}

export default ReactCSSTransitionGroup
